type OwnProps = {
  id?: string;
  children?: React.ReactNode;
};

const defaultProps: Partial<OwnProps> = {
  id: "details-picture",
};

type Props = OwnProps & typeof defaultProps;

function DetailsPicture({ id, children }: Props) {
  return (
    <div id={id} className="details-picture">
      {children}
    </div>
  );
}

DetailsPicture.defaultProps = defaultProps;

export default DetailsPicture;
